import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaProcessJobOverview from './media-process-job-overview-model'
import {
  delete_mediaProcessJobOverview,
  load_mediaProcessJobOverviews,
  store_mediaProcessJobOverview,
} from './mediaProcessJobOverview-service'

export const LoadMediaProcessJobOverviewsAsync = createAsyncThunk<any, any>(
  'composer/load/mediaProcessJobOverview',
  async (params: { uid: string }) => {
    return await load_mediaProcessJobOverviews(params)
  },
)

export const CreateMediaProcessJobOverviewAsync = createAsyncThunk<any, any>(
  'composer/create/mediaProcessJobOverview',
  async (params: MediaProcessJobOverview) => {
    return await store_mediaProcessJobOverview(params)
  },
)

export const DeleteMediaProcessJobOverviewAsync = createAsyncThunk<any, any>(
  'composer/delete/mediaProcessJobOverview',
  async (params) => {
    return await delete_mediaProcessJobOverview(params)
  },
)
